const USB_DAC_NAMES_KEY = 'maestro_usb_dac_names';

export function readUsbDacNames(): Record<string, string> {
  try { return JSON.parse(localStorage.getItem(USB_DAC_NAMES_KEY) || '{}'); } catch { return {}; }
}

export function writeUsbDacName(uid: string, name: string): void {
  const all = readUsbDacNames();
  all[uid] = name;
  localStorage.setItem(USB_DAC_NAMES_KEY, JSON.stringify(all));
}

export function getUsbDacDisplayName(device: { uid?: string; name: string }): string {
  if (device.uid) {
    const saved = readUsbDacNames()[device.uid];
    if (saved) return saved;
  }
  return device.name;
}

const USB_DAC_PROFILES_KEY = 'maestro_usb_dac_profiles';

export function isExclusiveModeEnabled(uid: string | undefined): boolean {
  if (!uid) return false;
  try {
    const profiles = JSON.parse(localStorage.getItem(USB_DAC_PROFILES_KEY) || '{}');
    const profile = profiles[uid];
    if (!profile) return true; // default ON for USB DACs with no profile yet
    return profile.exclusive_mode !== false;
  } catch {
    return false;
  }
}
